import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'

import { useMutation, useQueryClient } from '@tanstack/react-query'

type Payload = {
  page_url: string
  region_code: SEOCountries
  target_keyword?: string
  refreshable_page_id?: string
  existing_report_id?: string
}

const handleGenerateReport = async ({
  payload,
  companyId,
}: {
  payload: Payload[]
  companyId: string
}) => {
  try {
    const response = await axios.post(
      `${SEO_SERVICE_BASE_URL}/companies/${companyId}/content-gap/bulk`,
      payload
    )

    return response.data
  } catch (error) {
    return extract.error(error)
  }
}

export const useGenerateReport = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      payload,
      companyId,
    }: {
      payload: Payload[]
      companyId: string
    }) => handleGenerateReport({ payload, companyId }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['content-gap-url-refresh-reports'],
      })
      queryClient.invalidateQueries({
        queryKey: ['content-gap-domain-refresh-params-paginated'],
      })
    },
  })
}
